export enum CampaignStatusTypes {
  AwaitingSuperAdminApproval = 1,
  AwaitingChainAdminApproval = 2,
  AwaitingPublication = 3,
  Published = 4,
  Finished = 5,
  Declined = 6,
  Canceled = 7,
}
